import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { CollectorProfilePage } from "@/features/collector-profile/components/collector-profile-page";
import { useI18n } from "@/providers/i18n-provider";

// Tab «Perfil» (Journal) — perfil del coleccionista: destacados, marco
// estacional, stats sociales, favoritos/etiquetas y publicaciones. Módulo
// Wave 1 · W1-PROFILE (`features/collector-profile/`). Los ajustes de cuenta
// viven en `/profile` (icono de la cabecera); la privacidad en `/journal/privacy`.
function JournalRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Tu perfil de coleccionista`)}
      description={t(
        msg`Inicia sesión para construir tu perfil: destacados, marco estacional, favoritos y tu progreso social.`,
      )}
    >
      <CollectorProfilePage />
    </AuthPlaceholder>
  );
}

export const journalRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/journal",
  component: JournalRoutePage,
});
